import { Preferences } from "../../profile/objects/preferences";
import { DEFAULT_COLUMN, CMS_MODULE } from "../constant/cmsConstant";
import { Column } from "../objects/column";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setCmsPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: CMS_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '-created_date',
    });
